import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import type RouterService from '@ember/routing/router-service';

class ScansScanProductIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.transitionTo('scans.scan.product.observations');
  }
}

export default instrumentRoutePerformance(ScansScanProductIndexRoute);
